// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3-2Dc","resendInfoText":"OnGoingPaymentBox_resendInfoText__2-6Gr"};